























import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
	props: {
		answers: {
			type: Array,
			default: () => ([]),
			required: true,
		},
		correct: {
			type: Number,
			required: true,
		},
		correctMsg: {
			type: String,
			default: 'Correct!',
		},
		wrongMsg: {
			type: String,
			default: 'Wrong!',
		},
	},
	data: () => ({
		usersAnswer: undefined,
	}),
	methods: {
		setAnswer(index: number) {
			this.usersAnswer = index;
			this.$emit('answer', index);
		},
	},
});
